import axios from "axios";

export default {
  name: "categorieProductSection",
  data() {
    return {
      ArticleCategorie: [],
    };
  },
  async created() {
    axios
      .post(
        "https://giftstore-blog.herokuapp.com/api/bestSelling/getAll"
      )
      .then((response) => {
        console.log("cata",response)
        this.ArticleCategorie=response.data.bestSelling
      })
      .catch((error) => {
        console.error("There was an error!", error);
      });
  },
  methods:{
    imgCategorie(image){
      return 'https://res.cloudinary.com/dpy824jnw/image/upload/v1604061374/'+image
    },
    typeDisplayArticle(index){
      console.log(index%2)
      if(index%2==0){
        return true
      }else{
        return false
      }
    }
  }
};
